import type { BrandSlug } from '../shared/brand-slug';
import type { ChunkProgressReporter } from '../shared/chunk-progress';
import type { EAN } from '../shared/ean';
import type { Brand } from './brand';

export abstract class BrandRepository {
  abstract getBySlug(slug: BrandSlug): Promise<Brand | null>;
  abstract lookupMany(slugs: readonly BrandSlug[]): Promise<ReadonlyMap<BrandSlug, Brand>>;
  abstract brandsOfBatch(eans: readonly EAN[]): Promise<ReadonlyMap<EAN, BrandSlug>>;

  /**
   * The catalog's stored thumbnail path per EAN, for the EANs the catalog holds. The value
   * is null when the catalog row carries no image; an EAN absent from the map is one the
   * catalog does not hold. Callers resolve the path to a URL themselves.
   */
  abstract thumbnailsOf(
    eans: readonly EAN[],
    onProgress?: ChunkProgressReporter
  ): Promise<ReadonlyMap<EAN, string | null>>;
}
